import React from "react"
import { IDate } from "../../models"
import * as timeHelper from "../../helpers/timeHelper"
import moment from "moment"

interface IProps {
    utcTime: IDate
    hierarchyId: string
    jobId: string
    formatStr?: string
}
interface IState {
    clientLocalTime: IDate
}

export default class ClientLocalDateTimeStr extends React.Component<IProps, IState>  {
    constructor(props: IProps) {
        super(props)
        this.state = {
            clientLocalTime: null
        }
    }

    async componentDidMount() {
        const clientLocalTime = await timeHelper.getDateTime(this.props.hierarchyId, this.props.jobId, this.props.utcTime)
        this.setState({ clientLocalTime })
    }

    render() {
        if (!this.state.clientLocalTime) return null
        return (
            <span>
                {this.props.formatStr ?
                    moment(this.state.clientLocalTime).format(this.props.formatStr) :
                    moment(this.state.clientLocalTime).format()
                }
            </span>
        )
    }
}